<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" style="width:100%;">
      <div class="back_styles" @click="goBackBtn">
        <Icon class="back_icon" type="ios-arrow-back"/>
        <span class="back_txt">{{ $t('key1002627') }}</span>
      </div>
      <div>
        <Button type="primary" @click="queryOrderBtn">{{ $t('key1000555') }}</Button>
      </div>
    </div>
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" class="basic_item">
            <span class="line_title">{{ $t('key1006843') }}</span>
            <Select v-model="ymsWarehouseId" filterable @on-change="ymsWarehouseIdChange">
              <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
            </Select>
          </Col>
        </Row>
        <div class="table_box">
          <div class="options_styles_btn">
            <Button type="primary" icon="md-add" :disabled="!ymsWarehouseId" @click="showAddProductModal">{{ $t('key1001092') }}</Button>
            <Button type="error" icon="md-trash" @click="deleteProductBtn" style="margin-left: 15px;">{{ $t('key1005113') }}</Button>
          </div>
          <Table
            highlight-row
            border
            max-height="560"
            :loading="tableLoading"
            :columns="packageGoodsColumns"
            @on-selection-change="getSelectValue"
            :data="packageGoodsList">
            <template #shippingWarehouse="{row, index}">
              <Select v-model="packageGoodsList[index].warehouseId" filterable style="width: 170px;"
                class="mt2 mb2" transfer @on-change="(value)=>selectChange(value, row, index)"
                @on-open-change="(value) => openChange(value, row, index)">
                <Option v-for="item in packageGoodsList[index].shippingWarehouseList" :disabled="item.availableNumber<=0"
                  :value="item.warehouseId" :key="item.warehouseId" :label="item.warehouseName">
                  <div class="flex align-items-center justify-content-between">
                    <span :class="item.availableNumber<=0 ? '' : 'color-333'">{{ item.warehouseName }}</span>
                    <span class="font-size-12 color-999">{{ '（' + $t('key1003367') + (item.availableNumber || 0) + '）' }}</span>
                  </div>
                </Option>
              </Select>
            </template>
          </Table>
        </div>
      </Card>
    </div>
    <!--添加商品的弹窗-->
    <addCommonProductModal
      ref="addCommonProduct"
      modalWidth="1000"
      :showTree="false"
      :apiUrl="apiUrl"
      :showSelectSku="true"
      :parameters="parameters"
      systemType="supplier"
      @updateGoodsData="updateData">
    </addCommonProductModal>
    <!--无法备货提示弹窗-->
    <unableToStockUpModal ref="unableToStockUp"></unableToStockUpModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import addCommonProductModal from "@/components/common/addCommonProductModal.vue";
import Mixin from "@/components/mixin/common_mixin";
import api from "@/api";
import {getAllWarehouseData, getDataSetBatchList, getEnumList} from "@/utils/common";
import {insufficientInventory} from "@/utils/asist";
import unableToStockUpModal from "@/views/supplier/components/supplierOrder/unableToStockUpModal.vue";

export default {
  name: "initiateStocking",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      outboundType: null,
      ymsWarehouseId: null,
      selectGoodsList: [],
      packageGoodsList: [],
      packageGoodsColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 70,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000585'),
          key: 'imagePath',
          minWidth: 100,
          align: 'left',
          render: (h, params) => {
            return this.tableImg(h, params, 'imagePath');
          }
        },
        {
          title: 'SKU',
          key: 'sku',
          align: 'left',
          minWidth: 190
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000216'),
          key: 'cnName',
          align: 'left',
          minWidth: 180
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001342'),
          key: 'shippingWarehouse',
          minWidth: 220,
          align: 'center',
          slot: 'shippingWarehouse'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001104'),
          key: 'availableNumber',
          align: 'left',
          minWidth: 100,
          render: (h, params) => {
            return h('span', v.priceTransform(params.row.availableNumber));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001105'),
          key: 'totalSalesVolume',
          align: 'left',
          minWidth: 100,
          render: (h, params) => {
            return h('span', v.priceTransform(params.row.totalSalesVolume));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006908'),
          key: 'remark',
          align: 'left',
          minWidth: 160,
          render: (h, params) => {
            return h('Input', {
              props: {
                value: params.row.remark
              },
              style: {
                minWidth: '110px'
              },
              on: {
                input: (val) => {
                  v.$set(v.packageGoodsList[params.index], 'remark', val);
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          key: 'quantity',
          minWidth: 100,
          align: 'left',
          render: (h, params) => {
            let availableNumber = params.row.availableNumber || 0;
            return h('div', [
              h('InputNumber', {
                props: {
                  value: params.row.quantity ? params.row.quantity : null,
                  min: 0,
                  max: availableNumber,
                },
                style: {
                  width: '100px',
                  marginRight: '5px'
                },
                on: {
                  'on-change': num => {
                    v.$set(v.packageGoodsList[params.index], 'quantity', num);
                  }
                }
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'left',
          minWidth: 90,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: true,
                    clickFn: () => {
                      v.packageGoodsList.splice(params.index, 1);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      addProductModal: false,
      apiUrl: api.post_productGoods_query,
      warehouseList: [],
      parameters: {
        isSupportCustomization: 0,
        shelveStatus: 1
      },
      enumData: []
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 出库单类型
    outboundTypeList() {
      const ENUM_KEY = 'PackageInfoOutboundTypeSupplierEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list = list.filter(item => [2, 3].includes(item.value));
      return list;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = ['PackageInfoOutboundTypeSupplierEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);

      let query = {
        stockedWarehouse: 1,
        servicePlatform: 'core',
        status: 1
      };
      this.warehouseList = await getAllWarehouseData(query);
    },
    // 返回列表
    goBackBtn() {
      this.$router.push('/stockList');
    },
    // 获取已经选中的货品信息
    updateData(data) {
      let v = this;
      let list = JSON.parse(JSON.stringify(data));
      let new_arr = [...v.packageGoodsList, ...list];
      let newData = v.uniqueFunc(new_arr, 'productGoodsId');
      let productGoodsIds = [];
      if (newData.length > 0) {
        newData.map((item) => {
          if (item.productGoodsId) {
            productGoodsIds.push(item.productGoodsId);
          }
          if (!item.warehouseId) {
            item.warehouseId = null;
          }
        });
        productGoodsIds = v.uniqueFunc(productGoodsIds);
        if (productGoodsIds.length > 0) {
          this.inventoryOfStockedGoods(productGoodsIds).then((data) => {
            if (data.length > 0) {
              newData.map((ele) => {
                data.map((item) => {
                  if (ele.productGoodsId === item.productGoodsId) {
                    let list = item.productDeliverWarehouseResultBos || [];
                    let newList = list.sort((a, b) => b.availableNumber - a.availableNumber);
                    newList.map((talg) => {
                      if (talg.warehouseId === ele.warehouseId) {
                        ele.availableNumber = talg.availableNumber;
                      }
                    });
                    ele['shippingWarehouseList'] = newList;
                    if (!ele.warehouseId) {
                      ele.warehouseId = newList[0].warehouseId;
                      ele.availableNumber = newList[0].availableNumber;
                    }
                  }
                });
              });
            }
            this.packageGoodsList = newData;
          });
        }
      }
    },
    // 勾选列表数据
    getSelectValue(value) {
      this.selectGoodsList = [];
      if (value) {
        value.map((item) => {
          this.selectGoodsList.push(item.productGoodsId);
        });
      }
    },
    // 添加商品
    showAddProductModal() {
      this.$refs['addCommonProduct'].initFun();
      this.$refs['addCommonProduct'].selectTableData = this.packageGoodsList;
    },
    // 移除商品
    deleteProductBtn() {
      let new_arr = [];
      if (this.selectGoodsList.length > 0) {
        this.packageGoodsList.map((item, index) => {
          if (!this.selectGoodsList.includes(item.productGoodsId)) {
            new_arr.push(item);
          }
        });
        this.packageGoodsList = new_arr;
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005948'));
      }
      this.selectGoodsList = [];
    },
    // 选择发货仓
    selectChange(value, obj, index) {
      let shippingWarehouseList = obj.shippingWarehouseList || [];
      let availableNumber = shippingWarehouseList.filter((ele) => ele.ymsWarehouseId === value)[0].availableNumber;
      if (obj.quantity > availableNumber) {
        this.$set(this.packageGoodsList[index], 'quantity', availableNumber);
      }
      this.$set(this.packageGoodsList[index], 'availableNumber', availableNumber);
    },
    // 展开选择发货仓下拉框
    openChange(value, obj, index) {
      let shippingWarehouseList = obj.shippingWarehouseList || [];
      if (value && shippingWarehouseList.length <= 0) {
        this.inventoryOfStockedGoods([obj.productGoodsId]).then((data) => {
          if (data.length > 0) {
            data.map((item) => {
              if (item.productGoodsId === obj.productGoodsId) {
                let list = item.productDeliverWarehouseResultBos || [];
                let newData = list.sort((a, b) => b.availableNumber - a.availableNumber);
                this.$set(this.packageGoodsList[index], 'shippingWarehouseList', newData);
                this.$forceUpdate();
              }
            });
          }
        });
      }
    },
    // 保存
    queryOrderBtn() {
      let v = this;
      let query = {
        outboundType: 2,
        ymsWarehouseId: null,
        packageGoodsList: [],
      };
      if (v.ymsWarehouseId) {
        query.ymsWarehouseId = v.ymsWarehouseId;
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006909'));
        return false;
      }
      if (v.packageGoodsList.length > 0) {
        for (let i = 0; i < v.packageGoodsList.length; i++) {
          let item = v.packageGoodsList[i];
          if (item.quantity === null || item.quantity === 0) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006910'));
            return false;
          } else {
            let reg = v.$regular.positiveInteger;
            if (!reg.test(Number(item.quantity))) {
              v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006911'));
              return false;
            }
            if (item.warehouseId) {
              query.packageGoodsList.push({
                productGoodsId: item.productGoodsId,
                quantity: item.quantity,
                remark: item.remark,
                warehouseId: item.warehouseId
              });
            } else {
              v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006912'));
              return false;
            }
          }
        }
        v.tableLoading = true;
        v.axios.post(api.post_packageInfo_createStock, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
            v.goBackBtn();
          }
          // 库存不足提示
          else if (response.data.code === 1112947) {
            insufficientInventory(response.data.others, () => {
              v.updateData(v.packageGoodsList);
            });
          }
          // 无法备货提示，所在仓库对应的国家供货价没有维护
          else if (response.data.code === 1113049) {
            let errorMessageList = JSON.parse(response.data.others?.errorMessage) || [];
            let obj = this.warehouseList.find((ele) => ele.ymsWarehouseId == v.ymsWarehouseId);
            v.$refs['unableToStockUp'].initUnableToStockUpData(obj, errorMessageList);
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005977'));
      }
    },
    // 选择目的仓库
    ymsWarehouseIdChange(value) {
      this.packageGoodsList.map((item) => {
        item.warehouseId = null;
      });
      let productGoodsIds = this.packageGoodsList.map(item => item.productGoodsId).filter(Boolean);
      productGoodsIds = this.uniqueFunc(productGoodsIds);
      if (productGoodsIds.length > 0) {
        this.inventoryOfStockedGoods(productGoodsIds).then((data) => {
          if (data.length > 0) {
            this.packageGoodsList.map((ele) => {
              data.map((item) => {
                if (ele.productGoodsId === item.productGoodsId) {
                  let list = item.productDeliverWarehouseResultBos || [];
                  let newList = list.sort((a, b) => b.availableNumber - a.availableNumber);
                  newList.map((talg) => {
                    if (talg.warehouseId === ele.warehouseId) {
                      ele.availableNumber = talg.availableNumber;
                    }
                  });
                  ele['shippingWarehouseList'] = newList;
                  if (!ele.warehouseId) {
                    ele.warehouseId = newList[0].warehouseId;
                    ele.availableNumber = newList[0].availableNumber;
                  }
                }
              });
            });
          } else {
            this.packageGoodsList.map((ele) => {
              ele['shippingWarehouseList'] = [];
            });
          }
        });
      }
    },
    // 获取备货商品库存
    inventoryOfStockedGoods(productGoodsIds) {
      let query = {
        ymsWarehouseId: this.ymsWarehouseId,
        productGoodsIds: productGoodsIds,
        type: 1
      };
      return new Promise((resolve) => {
        this.axios.post(api.post_productGoods_queryStockGoodsInventory, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              let list = this.handerGrouping(data, function (item) {
                return [item.productGoodsId];
              }, 'productGoodsId', 'productDeliverWarehouseResultBos');
              resolve(list);
            } else {
              resolve([]);
            }
          }
        });
      });
    },
  },
  components: {
    addCommonProductModal,
    unableToStockUpModal
  }
};
</script>

<style lang="less" scoped>
.details_box_styles {
  .basic_information_box {
    .options_styles_btn {
      margin: 15px 0;
    }
  }

  .go_back {
    display: flex;
    justify-content: space-between;
    cursor: initial;

    .back_styles {
      display: flex;
      cursor: pointer;
    }
  }
}

</style>